// src/contexts/OpeningHoursContext.js

import React, { createContext, useState, useEffect, useContext } from 'react';
import { apiFetch } from '../services/apiService';

const OpeningHoursContext = createContext();

export const useOpeningHours = () => useContext(OpeningHoursContext);

export const OpeningHoursProvider = ({ children }) => {
    const [content, setContent] = useState('');

    const fetchOteviraciDoba = async () => {
        try {
            const data = await apiFetch('/api/general/getOteviraciDoba');
            setContent(data.content);
        } catch (error) {
            console.error('Chyba při načítání otevírací doby:', error);
        }
    };

    useEffect(() => {
        fetchOteviraciDoba();
    }, []);

    return (
        <OpeningHoursContext.Provider value={{ content, setContent, fetchOteviraciDoba }}>
            {children}
        </OpeningHoursContext.Provider>
    );
};
